'use strict'
module.exports = {
  VERSION: "1.0.0",
  NODE_ENV: '"production"',
  // NOTE:自添加项,测试服链接地址
  PORTAL_URL: '"https://portal-xunyou.qingcdn.com/"'
}
